import * as React from "react";

export const Avatar = ({ imageUrl, size }) => {
    return (
        <img className={'element__avatar'} src={imageUrl} alt="Avatar" style={{ width: size, height: size, borderRadius: '50%' }} />
    );
};

export default Avatar;